module.exports = __webpack_public_path__ + "static/media/bakery_and_bread@3x.d9daff85.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bakery_and_bread@3x.png
// module id = 224
// module chunks = 1